import styles from './liveChat.module.css'

const LiveChatStyles = {
    chatContainer: `flex flex-col h-full w-full`,
    activity_text: `text-white mt-[6px] ${styles.activity_text}`,
    noactivity: `w-full h-auto max-w-[100px] ${styles.noactivity}`,
    commentaryContainer: `flex flex-col h-full w-full overflow-y-auto pr-2`,
    commentaryMessageContainer: `w-full flex items-center justify-center`,
    chatMessages: `flex-1 overflow-y-auto pr-2`,
    commentaryMessage: `flex-1 w-full max-w-full break-words whitespace-normal bg-themeOverlay text-left text-[13px] px-4 py-2 pr-8 relative text-white !font-inter ${styles.commentaryMessage}
                        before:content-[''] before:h-full before:w-[3px] before:bg-primaryHeading before:absolute before:left-0 before:top-0 
    `,
    mediaContainer: `${styles.mediaContainer}`,
    messageContainer: `relative inline-block break-words text-[13px] max-w-[90%] rounded-[12px] font-inter leading-[20px] font-[400] whitespace-pre-line ${styles.messageContainer}`,
    messageContainerUser: `10px 10px 0 10px`,
    messageContainerSender: `10px 10px 10px 0`,
    senderName: `text-[11px] font-[400] mt-1`,
    sendMessageContainer: `flex gap-[5px] items-center rounded-[30px] bg-themeColor bottom-0 relative border-[1px] overflow-hidden`,
    previewContainer: `absolute left-0 w-full p-2 bg-white border border-gray-300 rounded`,
    files: `w-full h-full`,
    attachmentAndEmojiMenu: `absolute right-0 bottom-[50px] z-[50]`,
    mediaUploadDialogMenu: `absolute w-full h-[200px] right-0 bottom-[50px] z-[50]`,
    emojiButton: `h-[20px] w-[20px] flex items-center justify-center ${styles.emojiButton}`,
    uploadBtn: `h-[20px] w-[20px] flex items-center justify-center ${styles.uploadBtn}`,
    attachmentButtons: `block w-full text-left hover:bg-gray-100`,
    mb3: `mb-3 ${styles.mb3}`,
    buttonContainer: `flex gap-[12px] mb-[12px] ${styles.buttonContainer}`,
    senderImageContainer: `max-h-[24px] max-w-[24px] rounded-full overflow-hidden`,
    senderImage: `w-[24px] h-[24px] object-cover ${styles.senderImage}`,
    input_field_wrpr: `flex items-end w-full bg-themeColor rounded-[10px] pl-[8px] pr-[14px]
                        screen-500:rounded-[20px] screen-500:pl-[10px] screen-500:pr-[18px]
    `,
    sendButton: `min-w-[38px] min-h-[38px] max-w-[38px] max-h-[38px] flex items-center justify-center p-2 bg-themeColor rounded-[10px] ${styles.sendButton}
                screen-500:rounded-full
    `,
    bottom_send_message_wrpr: `relative flex items-end w-full gap-[6px]`,
}

const SelectTabStyles = {
    sectionContainer: `flex flex-col w-full gap-2
        screen-500:gap-0
    `,
    // fixedTabContainer: ``, 
    scrollableContent: `rounded-[0px_10px_10px_10px] p-1 bg-themeShadowColor pl-3
                        screen-500:max-w-[575px] screen-500:min-w-[575px] screen-500: h-[400px] screen-500:p-[10px]
                        md:max-h-[475px] md:min-h-[475px] ${styles.scrollableContent}`,
}

const ImageMessageStyles = {
    messageContainer: `inline-block break-words whitespace-normal bg-white text-black text-left text-[13px] text-themeColor max-w-[90%] border-[1px] border-liveChatBorder overflow-hidden`,
    messageContainerUser: `10px 10px 0 10px`,
    messageContainerSender: `10px 10px 10px 0`,
    chatMessages: `p-2`,
    senderName: `text-[11px] font-[400] mt-1`, 
    imageContainer: `max-h-[200px] max-w-[200px]`,
    image: `h-full w-full object-cover`,
}

const VideoMessageStyles = {
    messageContainer: `inline-block break-words whitespace-normal bg-white text-black text-left text-[13px] text-themeColor max-w-[90%] border-[1px] border-liveChatBorder overflow-hidden`,
    messageContainerUser: `10px 10px 0 10px`,
    messageContainerSender: `10px 10px 10px 0`,
    chatMessages: `p-2`,
    senderName: `text-[11px] font-[400] mt-1`,    
    videoContainer: `max-h-[200px] max-w-[300px]`,
    video: `h-full w-full object-cover`,
}

const FilePreviewStyles = {
    outerContainer: `flex gap-2 overflow-x-auto relative`,
    filesPreviewContainer: `min-w-[55px] min-h-[55px] max-w-[60px] max-h-[60px] border border-gray-300 relative`,
    files: `w-full h-full`,
    cancel_icon: `absolute top-1 right-1 cursor-pointer max-h-[10px] max-w-[10px]`
}

const GalleryStyles = {
    outerContainer: `relative w-full h-full flex flex-col gap-2 border-box justify-start items-start transition-all duration-300 ease-in-out py-[10px] ${styles.outerContainernew}`,
    galleryOuterContainer: `w-full h-full flex flex-col gap-2`,
    galleryContainer: `w-full flex justify-between`,
    dragAndDropOuterContainer: `absolute w-full h-[170px] right-0 bottom-[35px] flex flex-col gap-2 border-box p-2 bg-white bg-opacity-10 backdrop-blur-xl border-[1px] border-dashed rounded-md border-lightborderColor
                                screen-500:bottom-[50px] screen-500:h-[200px]
    `,
    // dragAndDropOuterContainer: "w-full max-w-[600px] h-full flex gap-2 border-box bg-black p-2 overflow-hidden",
    dragAndDropContainer: " flex flex-col gap-3 justify-center items-center cursor-pointer",
    // icon: "text-lg p-1 border-[1px] border-white rounded-full ",
    uploadOuterContainer: "w-full flex flex-col gap-2 justify-start items-center",
    uploadContainerHeader: "w-full flex justify-between items-center ",
    uploadedFilesPreviewContainer: "w-full flex gap-1 justify-start z-10 overflow-y-auto top-10",
    noFileSelected: `mt-2 text-center ${styles.noFileSelected}`,
    previewFileContainer: `relative min-w-[110px] max-w-[110px] h-[110px] rounded-md text-center hover:cursor-pointer ${styles.previewFileContainer}
                            screen-500:min-w-[150px] screen-500:max-w-[150px] screen-500:h-[150px]
    `,
    mainContainer: 'w-full flex flex-col flex-1',
    noFileFound: "w-full h-full flex flex-col justify-center items-center overflow-y-auto overflow-x-hidden",
    noMediatext: `text-white ${styles.noMediatext} `,
    medianoimage:`max-w-[250px] ${styles.medianoimage}`,
    previewWrapper: `relative w-full h-fit group ${styles.previewWrapper}`,
    uploadButton: `!px-[12px] !py-[4px] !text-[14px] gap-[5px] ${styles.uploadButton}`,
    galleryButton: `!px-[12px] !py-[4px] !text-[14px] gap-[5px] ${styles.galleryButton}`,
    rejectedFileOverlay: `relative w-full h-full group ${styles.rejectedFileOverlay}`,
    rejectedFileMessage: 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white text-sm z-20 flex flex-col whitespace-normal group-hover:flex',
    previewFile: "w-full h-full object-cover rounded-md cursor-pointer",
    removeButton: "absolute top-1 right-1 bg-smallButton text-white w-[18px] h-[18px] text-[14px] rounded-full p-1 z-30 hover:bg-black/70",
    detailContainer: 'absolute bottom-2 left-1 hidden z-10 flex justify-around group-hover:block',
    button: `flex gap-1 justify-center items-center w-fit text-themeColor text-center text-[14px] bg-mediaGalleryButtonBlue hover:bg-mediaGalleryButtonBlueHovered hover:text-white transition-all duration-200 ease-in cursor-pointer rounded-md py-1 px-4 group `,
    rotate: `${styles.rotate}`,
    uploadicon: `border-[1px] border-white rounded-full ${styles.uploadicon}`,
    uploadedFiles: `text-[14px] ${styles.uploadedFiles}`,
    uploadedbuttons: `flex gap-2 ${styles.uploadedbuttons}`,
    icon: `group-hover:fill-white group-hover:brightness-0 group-hover:invert transition-all duration-100 ease-in ${styles.icon}`,
    filter: 'w-full flex justify-between py-2',
    dragAndDropText: `w-full flex flex-col items-center gap-1 ${styles.dragAndDropText}`,
    dragAndDropSubText: `w-full px-2 flex flex-col justify-center text-center text-xs ${styles.dragAndDropSubText}`,
    filterButton: `py-0.5 flex flex-1 justify-center rounded-sm `,
    labelText: 'text-inter text-white text-[14px] font-medium',
    checkbox: 'w-[16px] h-[16px] focus:outline-none cursor-pointer',
    clear: 'bg-white text-black',
    apply: 'bg-primaryGold text-themeColor',
    goldButton: `text-themeColor p-0.5 text-center ${styles.goldButton}`,
    maximizeButton: "absolute top-1 left-1 bg-smallButton text-white w-[18px] h-[18px] text-[14px] rounded-full z-30 flex justify-center items-center hover:bg-black/70",
    fullScreenContainer: "fixed inset-0 z-50 bg-black bg-opacity-70 flex items-center justify-center",
    fullScreenCloseButton: "absolute top-4 right-4 text-white hover:bg-white/20 rounded-full p-2",
    fullScreenFile: "max-w-full max-h-[90%] object-contain",
    senderImageContainer: `max-h-[24px] max-w-[24px] rounded-full overflow-hidden`,
    senderImage: `w-[24px] h-[24px] object-cover ${styles.senderImage}`,
    
    // Upload Styles for Progress
    progresMainContainer: `w-full mt-2 ${styles.progresMainContainer}`,
    progresTextMainContainer: `flex justify-between text-sm mb-1`,
    progresTextContainer: `text-gray-300 flex items-center gap-1 ${styles.progresTextContainer}`,
    currentProgress: `text-gray-300 ${styles.currentProgress}`,
    progressBarMainContainer: `w-full h-1 min-h-1 bg-gray-700 rounded-full overflow-hidden`,
    progressBar: `h-full transform origin-left transition-transform duration-300 ease-in-out`,

    // for future reference only
    uploadOuterContainerNew: `w-full min-w-[380px] max-w-[380px] h-full flex flex-col gap-2 justify-start items-center ${styles.uploadOuterContainerNew}`,
    previewFileContainerNew: "w-full h-fit flex justify-between items-center rounded-sm text-center hover:cursor-pointer",
    previewFileNew: "w-full h-full py-2 px-4 flex justify-between text-black text-xs items-center gap-6 bg-gray-50 rounded-md",
    iconContainer: "bg-purple-100 rounded-full p-0.5 text-purple-300",
    upperContainer: "w-full flex justify-between",
    bottomContainer: "w-full flex justify-between",
    dragAndDropContainerInner: `min-w-[110px] max-w-[110px] h-[110px] border-[0.5px] border-white border-dashed rounded-md px-2 box-border
                                screen-500:min-w-[150px] screen-500:max-w-[150px] screen-500:h-[150px]
    `,
};

const livePollsStyle = {
    outerContainer: `flex flex-col h-full gap-1
        screen-500:h-[unset] screen-500:gap-[20px]
    `,
    heading: `text-[19px] font-Suisse font-[700] capitalize
            md:text-[22px] `,
    dividerContainer: `flex gap-2 w-[20%]`,
    divider: `bg-primaryHeading h-[2px]`,
    pollDataContainer: `flex flex-col gap-3 overflow-y-auto pr-2 pt-1 h-full
                        screen-500:max-h-[380px]
                        md:max-h-[450px]
                        sm:pt-2
                        lg:pt-0
    `,
    loaderContainer: `w-full h-full flex flex-col items-center justify-center`,
    noPollsContainer: `flex flex-col items-center justify-center py-10 w-full h-full`,
    noPollsIcon:  `w-full h-[auto] max-w-[100px] ${styles.noPollsIcon}`,
    noPollsText: `text-white text-[16px] mt-[12px] ${styles.noPollsText}`,
};

const ZoneStyles = {
    container: `flex flex-col h-full w-full overflow-y-auto pr-2 gap-1
                screen-500:gap-2
    `,
    zoneButton: `rounded-[8px] bg-liveGameBackground p-1 flex items-center justify-center min-w-[40px] text-sm
                screen-500:p-2 screen-500:text-base
    `,
    goBackBtn: `text-[13px] underline-offset-3 active:underline`,
    activeZoneButton: `bg-liveGamePrimaryColor`,
    zonesWrapper: `grid grid-cols-5 gap-1.5 w-full
                    screen-500:hidden
    `
};

const zoneTableStyles = {
    tableContainer: `w-full bg-themeColor rounded-[10px] p-[6px] space-y-[6px] font-Kanit mt-1
                    screen-500:px-[10px] screen-500:mt-0
    `,
    activity_row: `w-full py-[6px] px-[10px] flex items-center justify-between bg-themeShadowColor rounded-[10px]`,
    activity_skeleton_row: `w-full bg-gray-700 rounded-[10px]`,
    activity_row_text: `text-[11px] font-[400]`,
    table_headers: `flex items-center justify-between px-2
                    screen-500:px-3
    `,
    header_text: `font-[500] text-[11px]
                  screen-500:text-[14px]
    `
}

const ImagePreviewStyles = {
    fullScreenContainer: `fixed top-0 left-0 w-full h-full bg-black bg-opacity-90 flex items-center justify-center z-20`,
    container: `relative flex w-[150px] h-[160px]
                screen-500:w-[200px] screen-500:h-[200px]
    `,
    view_more_skelton: `absolute w-[100px] h-[80px] bg-gray-800 bg-opacity-50 flex items-center justify-center rounded top-20 left-2 text-white font-bold text-xs cursor-pointer
                        screen-500:w-[150px] screen-500:h-[120px] screen-500:text-sm
    `
}

const TotalRewardPoints = {
    container: `h-full w-full flex flex-col items-center justify-center gap-5 screen-500:hidden`,
    points_container: `flex flex-col items-center justify-center gap-1`,
    rewardPoints: `text-liveGameSecondaryColor text-[30px] font-[700]`,
    rewardPointHeading: `text-[18px] font-[700] text-Barlow text-white`
}

export { LiveChatStyles, zoneTableStyles, TotalRewardPoints, ImagePreviewStyles, SelectTabStyles, ImageMessageStyles, VideoMessageStyles, FilePreviewStyles, GalleryStyles, livePollsStyle, ZoneStyles };